<template>
  <div class="box-title-sub-s align-middle content-center">
    <p class="text-chplus-regular text-landingfade-dark">
      <slot></slot>
    </p>
  </div>
</template>

<script>
export default {
  name: "BoxTitleSubS"
};
</script>

<style lang="scss" scoped>
.box-title-sub-s {
  height: 1.624rem;
}

@media (min-width: 768px) {
  .box-title-sub-s {
    height: 1.856rem;
  }
}
</style>
